import { render, staticRenderFns } from "./loading.vue?vue&type=template&id=6cfbab6e&scoped=true&"
import script from "./loading.vue?vue&type=script&lang=js&"
export * from "./loading.vue?vue&type=script&lang=js&"
import style0 from "./loading.vue?vue&type=style&index=0&id=6cfbab6e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cfbab6e",
  null
  
)

export default component.exports